var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarShortlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.399,
    height: 13.782,
    viewBox: "0 0 10.399 13.782",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bookmark",
    d: "M35.241,0h-8a1.221,1.221,0,0,0-1.223,1.17V13a.907.907,0,0,0,.154.526.6.6,0,0,0,.494.257.892.892,0,0,0,.567-.239l3.578-3.037a.709.709,0,0,1,.868,0l3.566,3.037a.861.861,0,0,0,.553.239c.314,0,.62-.242.62-.783V1.17A1.183,1.183,0,0,0,35.241,0Z",
    transform: "translate(-26.022)",
    fill: "#387F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarShortlist);
export default __webpack_public_path__ + "static/media/sidebar-shortlist.4f76841731b6b2e0ff1f05f62d054321.svg";
export { ForwardRef as ReactComponent };